import styled from 'styled-components';
import theme from 'styles/theme';

export const EstimatedAmountManagePage = styled.div`
  .summeryBox {
    position: relative;
    padding: 20px;
    background-color: ${theme.backgroundColor.grey8};
    dl {
      dt {
        padding-bottom: 10px;
        color: ${theme.color.blue};
        font-size: 1.2rem;
      }
      dd {
        color: ${theme.color.blue};
        font-size: 2rem;
        font-weight: 700;
        span {
          font-size: 1.4rem;
          color: inherit;
        }
      }
    }

    .btnAccountView {
      width: 100%;
      height: 36px;
      margin-top: 20px;
      border: 1px solid #dcdce4;
      border-radius: 4px;
      background-color: ${theme.color.white};
      text-align: center;
      font-weight: 500;
    }
    .btnRefresh {
      position: absolute;
      top: 14px;
      right: 20px;
      font-size: 1.2rem;
      border-bottom: 1px solid #222;

      svg {
        margin-bottom: -2px;
      }
    }
  }

  .listWrapper {
    padding: 25px 20px 20px;
    .listHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .total {
        flex-shrink: 0;
        font-size: 1.1rem;
        span {
          font-weight: 600;
        }
      }
    }

    .noList {
      padding-top: 50px;
      font-size: 1.2rem;
      color: #78797c;
      text-align: center;
    }

    ul {
      border-top: 1px solid #444;
      li {
        list-style: none;
        margin-left: 0;
        padding: 20px 0;
        dl {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          line-height: 24px;
          dt {
            width: 35%;
            font-size: 1.2rem;
            color: #6f727a;

            &.top {
              padding-bottom: 10px;
              font-size: 1.6rem;
              font-weight: 600;
              color: #111;
            }
          }
          dd {
            width: 65%;
            font-size: 1.2rem;
            text-align: right;
            &.top {
              padding-bottom: 10px;
              font-size: 1.6rem;
              font-weight: 600;
              span {
                button {
                  vertical-align: text-top;
                }
                svg {
                  vertical-align: text-bottom;
                }
              }
            }
            span {
              text-align: right;
            }
          }
        }

        & + li {
          border-top: 1px solid #d0d0d0;
        }
      }
    }
  }
`;

export const EstimatedAmountDetailPage = styled.div`
  padding: 20px;

  .updateDate {
    margin-bottom: 30px;
    font-size: 1.2rem;
    color: #6f727a;
  }
  section {
    .title {
      padding-bottom: 20px;
      font-size: 1.5rem;
      font-weight: 600;
    }

    &.mallInfo {
      dl {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        font-size: 1.2rem;
        line-height: 1.6rem;
        dt {
          min-width: 140px;
          padding-bottom: 10px;
          color: #6f727a;
          &:last-of-type {
            padding-bottom: 0;
          }
          button {
            height: 16px;
            vertical-align: top;
          }
        }
        dd {
          padding-bottom: 10px;
          width: calc(100% - 140px);
          text-align: right;
          &:last-of-type {
            padding-bottom: 0;
          }
        }
      }
    }
    &.estimatedInfo {
      position: relative;

      ul {
        li {
          list-style: none;
          margin-left: 0;
          margin-bottom: 5px;
        }
      }
      dl {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        padding: 0 10px;
        border: 1px solid #dcdce4;
        border-radius: 4px;
        font-size: 1.2rem;
        &.total {
          border-color: #02a4ff;
          font-size: 1.4rem;
          font-weight: 500;
          dt {
            color: #02a4ff;
          }
          dd {
            color: #02a4ff;
          }
        }
      }
      .checkBox {
        position: absolute;
        top: -3px;
        right: 0;

        button {
          height: 16px;
        }
      }
    }

    &.settlementInfo {
      .tabBox {
        display: flex;
        button {
          width: calc(100% / 3);
          height: 50px;
          border-bottom: 2px solid transparent;
          text-align: center;
          line-height: 1.6rem;

          &.active {
            color: #2e65f3;
            border-color: #2e65f3;
          }
        }
      }
    }
    & + section {
      margin-top: 50px;
    }
  }

  .tableWrap {
    margin-top: 20px;
    height: 460px;
    overflow: scroll;
    scrollbar-width: thin;

    table {
      width: 100%;
      border-collapse: separate;
      th {
        position: sticky;
        top: 0;
        padding: 10px;
        width: 110px;
        background: ${theme.backgroundColor.table};
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        border-top: 2px solid ${theme.borderColor.grey5};
        border-bottom: 1px solid ${theme.borderColor.lightGrey};
        font-weight: 600;
        line-height: 1.4rem;
        font-size: 1.2rem;

        button {
          height: 16px;
          vertical-align: text-top;
        }
      }

      td {
        padding: 10px;
        white-space: nowrap;
        border-bottom: 1px solid ${theme.borderColor.lightGrey};
        text-align: right;
        font-size: 1.2rem;

        &.noList {
          position: absolute;
          left: 0;
          right: 0;
          border-bottom: 0;
          p {
            padding: 20px;
            text-align: center;
            color: #6f727a;
          }
        }
      }
    }
  }
`;

export const EstimatedAmountAccountPage = styled.div`
  padding: 20px;

  section {
    .title {
      padding-bottom: 20px;
      font-size: 1.5rem;
      font-weight: 600;
      button {
        vertical-align: top;
      }
    }
    .amountDate {
      padding: 0 0 15px 2px;
      font-size: 1.2rem;
    }

    & + section {
      margin-top: 30px;
    }

    &.accountInfo {
      select {
        margin-top: 0;
      }
    }

    &.estimatedInfo {
      position: relative;

      .noList {
        padding-top: 50px;
        font-size: 1.2rem;
        text-align: center;
        color: #78797c;
      }
      .checkBox {
        position: absolute;
        top: -3px;
        right: 0;

        button {
          height: 16px;
        }
      }

      ul {
        li {
          list-style: none;
          margin-left: 0;
          padding: 12px;
          border: 1px solid #dcdce4;
          border-radius: 4px;

          & + li {
            margin-top: 5px;
          }

          dl {
            dt {
              font-size: 1.2rem;
              line-height: 1.8rem;
              span {
                color: #6f727a;
              }
            }
            dd {
              text-align: right;
              font-weight: 600;
              font-size: 1.2rem;
            }
          }
        }

        &.byAccount {
          li {
            dl {
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }
    }
    .total {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;
      padding: 12px;
      height: 42px;
      border: 1px solid ${theme.color.blue};
      border-radius: 4px;
      font-size: 1.4rem;
      dt,
      dd {
        color: ${theme.color.blue};
        font-weight: 600;
      }
    }
  }
`;
